import React from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import { useLanguage } from "../components/LanguajeContext";
import { translations } from "../utils/paymentSucessReservation";
import { FaCheckCircle } from "react-icons/fa";


const PaymentSuccessReservation = () => {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <>
      <Navbar />
      <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
        <div className="bg-white shadow rounded-lg p-8 max-w-lg text-center">
          <FaCheckCircle className="text-green-500 text-6xl mx-auto mb-4" />

          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            {t.payment.successTitle || (language === "es" ? "¡Pago Exitoso!" : "Payment Successful!")}
          </h1>

          <p className="text-gray-700 mb-6">
            {t.payment.successMessage ||
              (language === "es"
                ? "Tu reserva se ha confirmado y recibirás un correo con los detalles."
                : "Your booking has been confirmed, and you’ll receive an email with the details.")}
          </p>

          <button
            onClick={() => navigate("/")}
            className="px-6 py-3 bg-green-600 text-white rounded-md hover:bg-green-700 transition"
          >
            {t.payment.backToHome || (language === "es" ? "Volver al inicio" : "Back to Home")}
          </button>
        </div>
      </div>
    </>
  );
};

export default PaymentSuccessReservation;
